module.exports = __webpack_public_path__ + "static/media/kasta.1caa9089.mp3";